import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

/** A dropdown checklist for selecting multiple string options (replaces native <select multiple>). */
@Component({
  selector: 'app-multi-select-dropdown',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.css'],
})
export class MultiSelectDropdownComponent {
  @Input() options: string[] = [];
  @Input() selected: string[] = [];
  @Input() placeholder = 'Select…';
  @Output() selectedChange = new EventEmitter<string[]>();

  open = false;
  filter = '';

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      this.open = false;
    }
  }

  toggleOpen(): void {
    this.open = !this.open;
  }

  get filteredOptions(): string[] {
    const f = this.filter.trim().toLowerCase();
    if (!f) {
      return this.options;
    }
    return this.options.filter((o) => o.toLowerCase().includes(f));
  }

  isSelected(option: string): boolean {
    return this.selected.includes(option);
  }

  toggleOption(option: string): void {
    const next = this.isSelected(option)
      ? this.selected.filter((o) => o !== option)
      : [...this.selected, option];
    this.selectedChange.emit(next);
  }

  removeChip(option: string, evt: MouseEvent): void {
    evt.stopPropagation();
    this.selectedChange.emit(this.selected.filter((o) => o !== option));
  }

  clearAll(evt: MouseEvent): void {
    evt.stopPropagation();
    this.selectedChange.emit([]);
  }
}
